import { render, staticRenderFns } from "./BuyingTenders.vue?vue&type=template&id=458e1d0a&"
import script from "./BuyingTenders.vue?vue&type=script&lang=ts&"
export * from "./BuyingTenders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports